import { Node, mergeAttributes } from '@tiptap/core'

export default Node.create({
    name: 'iframe',
  
    addOptions: {
      inline: false,
      HTMLAttributes: {},
    },
  
    inline() {
      return this.options.inline
    },
  
    group() {
      return this.options.inline ? 'inline' : 'block'
    },

  
    draggable: true,
    atom:true,
  
    addAttributes() {
      return {
        src: {
          default: null,
        },
        title: {
          default: null,
        },
        frameborder: {
          default: null,
        },
        allow: {
            default: null
        },
        allowfullscreen: {
            default: null
        },
        tag: {
          default: 'external-video'
        },
        width: {
          default: '100%',
        },
        height: {
          default: '100%'
        },
        class: {
          default: null
        }
      }
    },
  
    parseHTML() {
      return [
        {
          tag: 'iframe[src]',
        },
      ]
    },
  
    renderHTML({ HTMLAttributes }) {
      if(HTMLAttributes.tag == 'external-video'){
        return ['div', {class: 'video-wrapper add-transparent-border'}, ['iframe', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]]
      }else {
        return ['div', {class: 'embedded-code-wrapper add-transparent-border'}, ['iframe', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]]
      }
      
    },
    addCommands() {
      return {
        setIframe: options => ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          })
        },
      }
    },

})